"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_PROMO_CODE_SETTINGS = void 0;
var enums_1 = require("./enums");
exports.DEFAULT_PROMO_CODE_SETTINGS = {
    enabled: false,
    descriptiveText: 'Promo Code',
};
